import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

/**
 * A service that allows NavigationMenuComponent to tell his width to other component that subscribes to
 */
@Injectable({
  providedIn: 'root',
})
export class MenuDisplayService {
  /**
   * Emit new menu width any time it change
   * @private
   */
  private _menuWidth$$: BehaviorSubject<number> = new BehaviorSubject(0);

  /**
   * Expose menu width observable
   */
  public menuWidth$ = this._menuWidth$$.asObservable();

  /**
   * Set the new value of menu width
   * @param menuWidth
   */
  public menuWidth(menuWidth: number) {
    this._menuWidth$$.next(menuWidth);
  }

  /**
   * Subscribe to menu width changes
   * @param next
   * @param error
   * @Deprecated :: use menuWidth$ instead
   */
  public subscribe(
    next: (width: number) => void,
    error?: (error) => void,
  ): Subscription {
    return this._menuWidth$$.subscribe({
      next: next,
      error: error,
    });
  }
}
